const categoryId = window.categoryData;
const baseUrl = window.location.pathname;
const storeCurrencyGlobalSetting = '$';
const accountId = "shopify-29979866";

const itemsPerPage = 48; 
let currentPage = 1;
let selectedFacets = getSelectedFacetsFromUrl();
let totalProducts = 0;
let isLoading = false;
// Store scroll position before leaving the page
let mscrollPosition = 0;
let isBFCache = false;

// Listen for pageshow to detect if page was restored from bfcache
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    isBFCache = true;
    // Restore scroll position from sessionStorage
    const savedPosition = sessionStorage.getItem('collectionScrollPos');
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
      sessionStorage.removeItem('collectionScrollPos');
    }
  }
});

// Save scroll position before navigating away
window.addEventListener('beforeunload', function () {
  sessionStorage.setItem('collectionScrollPos', window.scrollY.toString());
});

// Also save on pagehide (better for mobile)
window.addEventListener('pagehide', function () {
  sessionStorage.setItem('collectionScrollPos', window.scrollY.toString());
});

// Track scroll position continuously for better accuracy
window.addEventListener('scroll', function () {
  mscrollPosition = window.scrollY;
}, { passive: true });

// Helper to detect iOS devices.
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

if (!isIOS()) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  
  // Save scroll position when the page is hidden/unloaded.
  window.addEventListener('pagehide', function () {
    // Use the current pathname as part of the key to tie the scroll position to this page.
    const collectionKey = window.location.pathname;
    sessionStorage.setItem('collectionScrollPosition_' + collectionKey, window.scrollY);
  });
}

function hideQuickShopBadges(){
      const productBadgeContainers = document.querySelectorAll('.quickshop .product-badges');
      
        productBadgeContainers.forEach(container => {
          const badges = container.querySelectorAll('.badge');
          if (badges.length > 1) {
            let highestZIndex = -Infinity;
            let highestZIndexBadge = null;
      
            badges.forEach(badge => {
              const zIndex = parseInt(window.getComputedStyle(badge).zIndex);
              if (!isNaN(zIndex) && zIndex > highestZIndex) {
                highestZIndex = zIndex;
                highestZIndexBadge = badge;
              }
            });
      
            badges.forEach(badge => {
              if (badge !== highestZIndexBadge) {
                badge.style.opacity = '0'; // Adjust opacity value as needed
              }
            });
          }
        });
}

function updateURL(page, facets, sortOption) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('page', page);
    if (facets) {
      urlParams.set('facets', JSON.stringify(facets));
    } else {
      urlParams.delete('facets');
    }
    if (sortOption) {
      urlParams.set('sort', sortOption);
    } else {
      urlParams.delete('sort');
    }
    history.pushState(null, null, '?' + urlParams.toString());
  }
  
function getSelectedFacetsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const facetsParam = urlParams.get('facets');
    return facetsParam ? JSON.parse(facetsParam) : [];
  }

async function waitForNostojs() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (typeof nostojs !== 'undefined') {
          clearInterval(interval);
          resolve();
        }
      }, 100); 
    });
}
  
async function fetchSearchSessionParams() {
    await waitForNostojs();
    return new Promise((resolve) => {
      nostojs(api => {
        api.getSearchSessionParams().then(response => {
          resolve(response);
        });
      });
    });
}

async function fetchProducts(page, facets, sortOption) {
    const from = (page - 1) * itemsPerPage;
    const facetsFilter = facets.length > 0 ? customStringify(facets) : '[]';
    let sortBy = [];
    switch (sortOption) {
      case 'price-high-to-low':
        sortBy.push({ field: 'price', order: 'desc' });
        break;
      case 'price-low-to-high':
        sortBy.push({ field: 'price', order: 'asc' });
        break;
      case 'new':
        sortBy.push({ field: 'datePublished', order: 'desc' });
        break;
      case 'popularity':
      default:
        sortBy.push({ field: 'popularity', order: 'desc' });
        break;
    }
    
    const sessionParams = await fetchSearchSessionParams();
    const sessionParamsString = JSON.stringify(sessionParams).replace(/"([^"]+)":/g, '$1:');
    
    const graphqlQuery = `
      query {
        search(
          accountId: "${accountId}",
          sessionParams: ${sessionParamsString},
          products: {
            categoryId: "${categoryId}",
            size: ${itemsPerPage},
            from: ${from},
            facets: ["*"],
            filter: ${facetsFilter},
            sort: ${customSortStringify(sortBy)}
          }
        ) {
          products {
            hits {
              productId
              categoryIds
              name
              datePublished
              url
              imageUrl
              alternateImageUrls
              price
              listPrice
              priceCurrencyCode
              reviewCount
              tags1
              customFields {
                key
                value
              }
              skus {
                name
                price
                url
                availability
                id
                customFields{
                  key 
                  value
                }
              }
            }
            total
            size
            facets {
              ... on SearchTermsFacet {
                id
                field
                type
                name
                data {
                  value
                  count
                  selected
                }
              }
            }
          }
        }
      }
    `;
  
    const response = await fetch('https://search.nosto.com/v1/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: graphqlQuery })
    });
    return response.json();
  }
  
async function renderProductsAndPagination(page, facets, sortOption) {
  if (isLoading) return;
  isLoading = true;

  let allProducts = [];
  let allFacets = [];
  const productGridContainer = document.getElementById('ProductGridContainer');

  // If the container is empty, assume an initial load (or a reset) and load pages 1 to current page.
  // Otherwise, if products are already rendered (e.g. when clicking "Show more"),
  // load only the new products.
  const loadAllPages = productGridContainer.innerHTML.trim() === '';
  

  if (loadAllPages) {
    // Loop through pages 1 up to the current page and combine the products.
    for (let i = 1; i <= page; i++) {
      const data = await fetchProducts(i, facets, sortOption);
      if (data.data && data.data.search && data.data.search.products) {
        const products = data.data.search.products.hits;
        totalProducts = data.data.search.products.total;
        allProducts = allProducts.concat(products);
        allFacets = data.data.search.products.facets;
      } else {
        console.log('Products data is not available in the response for page', i);
      }
    }
  } else {
    // Just fetch the current page (for "Show more" clicks)
    const data = await fetchProducts(page, facets, sortOption);
    if (data.data && data.data.search && data.data.search.products) {
      const products = data.data.search.products.hits;
      totalProducts = data.data.search.products.total;
      allProducts = products;
      allFacets = data.data.search.products.facets;
    } else {
      console.log('Products data is not available in the response.');
    }
  }

  // Track category page visit using recordSearch (this is done only for the current page's products)
  nostojs(api => {
    api.recordSearch(
      'category',
      {
        products: {
          categoryId: categoryId,
          filter: facets,
          sort: [{ field: sortOption }],
        }
      },
      {
        products: {
          hits: loadAllPages ? allProducts : allProducts,
          total: totalProducts,
          size: itemsPerPage,
          from: (page - 1) * itemsPerPage,
          categoryId: categoryId
        }
      }
    );
  });

if (facets && facets.length > 0) {
  // Look for the facet with field "skus.customFields.size"
  const sizeFacet = facets.find(facet => facet.field === 'skus.customFields.size');
  if (sizeFacet && sizeFacet.value && sizeFacet.value.length > 0) {
    const selectedSizes = sizeFacet.value;
    allProducts = allProducts.filter(product =>
      product.skus && product.skus.some(sku => {
        // Try to get the SKU's size from its customFields; fallback to sku.name if not found
        let skuSize = sku.name;
        if (sku.customFields && sku.customFields.length > 0) {
          const sizeField = sku.customFields.find(cf => cf.key === 'size');
          if (sizeField) {
            skuSize = sizeField.value;
          }
        }
        return selectedSizes.includes(skuSize) && sku.availability !== "OutOfStock";
      })
    );
  }
}


  
  // If we loaded all pages (e.g. on an initial load), clear and render them.
  // Otherwise, just append the newly fetched products.
  if (loadAllPages) {
    renderProducts(allProducts);
  } else {
    appendProducts(allProducts);
  }
  renderFacets(allFacets);
  updateProductCountText();
  updateProgressBar();
  hideLoadMoreButtonIfNecessary();

  attachEventListenersToButtons(); // Attach event listeners to the buttons

  updateSelectedFacetsDisplay(selectedFacets);
  hideLoader();
  isLoading = false;
  setTimeout(() => {
    initializeQuickShop();
  }, 700);
}

function appendProducts(products) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    products.forEach(product => {
      const productElement = createProductElement(product);
      productGridContainer.appendChild(productElement);
  
      // Attach event listener for product clicks
    productElement.querySelector('a').addEventListener('click', function() {
      nostojs(api => {
          api.recordSearchClick(
            'category',
            { productId: product.productId, url: product.url }
          );
      });
    });
  });
}
  
function updateProductCountText() {
  const showingCount = currentPage * itemsPerPage > totalProducts ? totalProducts : currentPage * itemsPerPage;
  document.getElementById('ProductCountText').innerText = `Showing ${showingCount} out of ${totalProducts} products`;
}
  
function updateProgressBar() {
  const progressPercentage = (currentPage * itemsPerPage / totalProducts) * 100;
  document.getElementById('ProgressBar').style.width = `${progressPercentage}%`;
}

function hideLoadMoreButtonIfNecessary() {
  const totalPages = Math.ceil(totalProducts / itemsPerPage);
  document.getElementById('LoadMoreButton').style.display = currentPage >= totalPages ? 'none' : 'block';
}
  
function attachEventListenersToFacets() {
    const facetContainers = document.querySelectorAll('.facet');
    facetContainers.forEach(container => {
      const facetValues = container.querySelectorAll('.facet-value-color, .facet-value');
      facetValues.forEach(valueElement => {
        valueElement.addEventListener('click', () => {
          valueElement.classList.toggle('selected');
          selectedFacets = collectSelectedFacets();
          updateURL(1, selectedFacets);
          currentPage = 1;
          document.getElementById('ProductGridContainer').innerHTML = ''; // Clear existing products
          renderProductsAndPagination(currentPage, selectedFacets);
          setTimeout(() => {
            console.log("facet-click");
            initializeQuickShop();
          }, 700);
        });
      });
    });
  }

   function reinitializeQuickShopSliders() {
    
    const quickShopColorVariantSliders = document.querySelectorAll('.quickshop .product-single__color-variants');
    const quickShopSlideshowSliders = document.querySelectorAll('.quickshop .product-slideshow');

    quickShopColorVariantSliders.forEach((slider) => {
      requestAnimationFrame(() => {
        const colorVariantItems = slider.querySelectorAll('.quickshop .product-single__color-variant');
        if (colorVariantItems.length > 4) {
          const qsflickityInstance = Flickity.data(slider);
          if (qsflickityInstance) {
            qsflickityInstance.destroy();
          }
          new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
          });
        }
      });
    });

    quickShopSlideshowSliders.forEach((slider) => {
      requestAnimationFrame(() => {
        // Measure BEFORE Flickity touches DOM
        const initialHeight = slider.scrollHeight; // full natural height
        slider.style.minHeight = initialHeight + 'px';

        // Init Flickity
        const flkty = new Flickity(slider, {
          adaptiveHeight: true,
          avoidReflow: true,
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
        });
      });
    });
    
  }

  function initializeQuickShop() {
    document.querySelectorAll('.mobile-atc-size-drawer').forEach(button => {
      button.addEventListener('pointerdown', async (event) => {
        event.preventDefault();
                const drawer = document.getElementById('quickshop');
        drawer.classList.add('open');
        const productHandle = button.getAttribute('data-product-handle');
        if (!productHandle) {
          console.error("Product handle not found.");
          return;
        }
        
        try {
          const response = await fetch(`/products/${productHandle}?view=ajax`);
          if (!response.ok) {
            throw new Error("Failed to fetch product page.");
          }
          
          const productHTML = await response.text();
          const ccartNostoCart = document.querySelector(".js-drawer-open-cart");
          const drawerContent = document.querySelector('.quickshop');
          if (drawerContent) {
            const headerHTML = `
               <div class="quickshop-header">
                    <div class="drawer__close">
                      <button type="button" class="drawer__close-button js-drawer-close">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799">
                          <g id="Group_4" data-name="Group 4" transform="translate(0.707 0.707)">
                            <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 0) rotate(45)" fill="none" stroke="#222" stroke-width="2"/>
                            <line id="Line_2" data-name="Line 2" x2="26" transform="translate(0 18.385) rotate(-45)" fill="none" stroke="#222" stroke-width="2"/>
                          </g>
                        </svg>
                        <span class="icon__fallback-text">{{ 'cart.general.close_cart' | t }}</span>
                      </button>
                    </div>
                    <div class="h1 site-header__logo" itemscope="" itemtype="http://schema.org/Organization">
                      <a href="/" itemprop="url" class="site-header__logo-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="98.439" height="26" viewBox="0 0 404.29 98.61"><polygon points="95.05 8.05 112.93 8.05 112.93 98.44 95.05 98.22 95.05 8.05" fill="currentColor"></polygon><path d="M336.18,243h17.93v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86s10.6-17.86,36.25-17.86c37.4,0,43.08,35.8,43.08,36.89v53.66H479l0-49.62s-.95-22.95-26-22.9c-24.85,0-27.52,22.9-27.52,22.9v49.61H407.67l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9l-.06,49.62H336.18Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M306.88,243l-.05,90.39h-18v-8s-13.35,9.15-26.26,8c-1.1-.11-43.47,1.11-44.35-47.13C218,245.49,258.12,243,258.12,243Zm-45.12,17.82s-25.49-2.35-25.71,25.51c1.8,29.34,26.81,28.7,26.81,28.7s22.95,1.9,25.91-21.78V260.86Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M501.08,243.1H519v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86a38.24,38.24,0,0,1,8.73,23.07c0,1.76,0,49.61,0,49.61H572.57l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9L519,333.48H501.08Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M495.61,235l-16.31,0,0,8.81a39.37,39.37,0,0,1,8.22,7.26c1.49,1.82,2.34,1.43,8.07,12.58Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M591.18,258.69c0-9.11,6.49-15.76,15.68-15.76s15.6,6.65,15.6,15.76-6.49,15.83-15.6,15.83S591.18,267.8,591.18,258.69Zm4.31,0c0,6.85,4.38,11.65,11.3,11.65s11.37-4.8,11.37-11.65S613.64,247,606.79,247,595.49,251.84,595.49,258.69Zm14.69,1.7,4.33,6.41-4.87.08-3.71-6.18h-1.31v6.18h-4v-16.6H608c3.47,0,5.79,2,5.79,5.17A4.92,4.92,0,0,1,610.18,260.39Zm-5.56-6.49v3.48h3.17a1.77,1.77,0,0,0,2-1.78c0-1.23-.93-1.7-2-1.7Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path></svg> 
                      </a>
                    </div>
                    <div class="drawer__empty-right"></div>
                </div>
            `;
            drawerContent.innerHTML = headerHTML + productHTML;
            yotpo.refreshWidgets();
            reinitializeQuickShopSliders();
            hideQuickShopBadges();
             lipscore.reInitWidgets();
            document.querySelectorAll('.size-selector-button').forEach(function(button) {

              button.addEventListener('click', function() {

                theme.SizeGuideModal.open();

              });

            });
               // Create and append overlay
            // const overlay = document.createElement('div');
            // overlay.className = 'quickshop-overlay';
            // overlay.style.cssText = `
            //   width: 100%;
            //   height: 100%;
            //   position: fixed;
            //   background: black;
            //   left: 50%;
            //   z-index: 1;
            //   top: 50%;
            //   transform: translate(-50%, -50%);
            //   opacity: 0.3;
            // `;
            // document.body.appendChild(overlay);

            // Function to close quickshop and remove overlay
            const closeQuickShop = () => {
              const quickshop = document.querySelector('.quickshop');
              if (quickshop) {
                quickshop.innerHTML = '';
                quickshop.style.display = 'none';
              }
              const existingOverlay = document.querySelector('.quickshop-overlay');
              if (existingOverlay) {
                existingOverlay.remove();
              }
            };
            // overlay.addEventListener('click', closeQuickShop);
            const closeButton = document.querySelector('.quickshop-header .drawer__close-button');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                const quickshop = document.querySelector('.quickshop');
                if (quickshop) {
                  quickshop.innerHTML = '';
                  quickshop.style.display = 'none';
                }
                                const existingOverlay = document.querySelector('.quickshop-overlay');
                if (existingOverlay) {
                  existingOverlay.remove();
                }
              });
            }
            drawerContent.style.display = 'flex';
            // ccartNostoCart.click();
                // Add event listeners to variant input elements for selection logic
            document.querySelectorAll('.quickshop .variant-input').forEach(input => {
              input.addEventListener('click', () => {
                // Remove .var-inpt-selected from all other variant inputs within the quickshop container
                document.querySelectorAll('.quickshop .variant-input').forEach(el => {
                  el.classList.remove('var-inpt-selected');
                });
                // Add .var-inpt-selected to the clicked variant input
                input.classList.add('var-inpt-selected');
              });
            });
            
           

              window._swat.fetch(function(r) {
      window.myWishList = r;

      if (window.myWishList.length > 0) {
        document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
      } else {
        document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
      };

      
        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (wishlistButtons.length == 0) return;

        wishlistButtons.forEach(function(button) {
          const empi = button.getAttribute('data-empi');
          const epi = button.getAttribute('data-epi');
          if (empi || epi) {
            const matching_arr = window.myWishList.filter(i => i.empi == empi || i.epi == epi);
            if (matching_arr.length == 0) return;
            button.classList.add('is-saved');
          }
        })
      
    });
            

//  function attachAddToCartEvent() {
//    console.log("what");
//  // Remove the existing event listener to prevent multiple bindings
//     const addToCartForm = document.querySelector('.quickshop .combined-product .product-form');
//     const newAddToCartForm = addToCartForm.cloneNode(true);
//     addToCartForm.parentNode.replaceChild(newAddToCartForm, addToCartForm);

//     // Attach the new event listener for form submission
//     newAddToCartForm.addEventListener('submit', function(event) {
//       event.preventDefault(); // Prevent the default form submission behavior

//       // Collect the form data
//       const formData = new FormData(this);

//       // Perform the AJAX request to add the product to the cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest', // Ensure the request is recognized as AJAX
//           'Accept': 'application/json' // Expect a JSON response from Shopify
//         }
//       })
//       .then(response => {
//         // Check if the response is OK, else throw an error
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then((data) => {
//         // Successfully added to cart, now open the cart drawer
//         document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: data }})); // Dispatch a custom event to update the cart
        
//         const cartDrawer = document.querySelector('.js-drawer-open-cart');
//         if (cartDrawer) {
//           cartDrawer.click(); // Open the cart drawer if the element exists
//         }
//         const quickshop = document.querySelector('.quickshop');
//                 if (quickshop) {
//                   quickshop.innerHTML = '';
//                   quickshop.style.display = 'none';
//                 }
//         cartDrawer.click();
//       })
//       .catch(error => {
//         console.error('Error adding item to cart:', error);
//       });
//     }); 
//   }
 initNoDrawerCheckoutCTA();
            
 function updateProductDetails(productUrl) {
    const newTitle = document.querySelector('.quickshop .product-single__title').textContent;
    document.title = newTitle;

    // Update the browser's URL
    // window.history.pushState({}, newTitle, productUrl);
   console.log("updateProductDetails");
    //  initNoDrawerCheckoutCTA();
     initNoDrawerCheckoutCTA();
  }

 function onVariantChange({ target: optionValueElement }) {

  const productElement = document.querySelector('.quickshop .combined-product');
  const sectionId = document.querySelector('.quickshop #productSection').dataset.sectionId;
  const oldProductUrl = productElement.dataset.productUrl;
  const newProductUrl = optionValueElement.dataset.productUrl;
  const productUrl = newProductUrl ? newProductUrl : oldProductUrl;
  const newVariantId = optionValueElement.dataset.variantId;
  let params = `section_id=${sectionId}&`;
 

  if (newVariantId) {
    params += `variant=${newVariantId}`;
  } else {
    const selectedOptionValues = Array.from(document.querySelectorAll('.quickshop fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
    params += `option_values=${selectedOptionValues}`;
  }

  // Clear selected class from all radio buttons and their parent divs
  document.querySelectorAll('.quickshop variant-input').forEach(div => div.classList.remove('selected'));
  document.querySelectorAll('.quickshop input[type="radio"]').forEach(input => input.classList.remove('selected'));

  // Add selected class to the clicked radio button and its parent div
  optionValueElement.classList.add('selected');
  optionValueElement.closest('.variant-input').classList.add('selected');

  fetch(`${productUrl}?${params}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      console.log(html);

      if (newProductUrl && oldProductUrl !== newProductUrl) {
        productElement.parentNode.insertBefore(html.querySelector('.combined-product'), productElement);
        productElement.remove();
     

        // Update the URL and title
        updateProductDetails(newProductUrl);
        reinitializeQuickShopSliders();
        yotpo.initWidgets();
        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
            console.log("im called");
          });
        });

        // Focus on the newly selected option
        document.querySelector(`#${optionValueElement.id}`).focus();

        // Reattach the event listeners for the updated product details
        console.log("this is called");
         initNoDrawerCheckoutCTA();
        return;
      }

      // // Update option selectors
      document.querySelector('.quickshop .optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;

      // Focus on the newly selected option
      document.querySelector(`#${optionValueElement.id}`).focus();

      // Update the price if necessary
      const priceEl = document.querySelector('.quickshop .product__price');
      if (html.querySelector('.product__price')) {
        priceEl.innerHTML = html.querySelector('.product__price').innerHTML;
      } else {
        priceEl.innerHTML = '';
      }

        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
          });
        });
      
      // Update Add to Cart form with the correct variant ID
      const addToCartForm = document.querySelector('.quickshop .product-form');
      const newVariantInput = html.querySelector('.product-form input[name="id"]');
      addToCartForm.querySelector('.quickshop input[name="id"]').value = newVariantInput.value;
      
    });
   
    setTimeout(function() {
    const sectionIdYotpo = document.querySelector('.quickshop #productSection .combined-product').dataset.sectionId;
    var yotpoWidget = document.querySelector('.quickshop .new-pdp-info .yotpo-widget-instance');
          // Check if the widget exists
          if (yotpoWidget) {
            // Set your custom Yotpo product ID
    
            // Change the data-yotpo-product-id attribute
            yotpoWidget.setAttribute('data-yotpo-product-id', sectionIdYotpo);
            
            console.log('Yotpo product ID changed to:', sectionIdYotpo);
            yotpo.refreshWidgets();
          } else {
            console.error('Yotpo widget not found.');
          }
    
      }, 1500); 
    
        }
        const quickshopproductSection = document.querySelector('.quickshop #productSection');
        if (quickshopproductSection) {
            quickshopproductSection.addEventListener('change', onVariantChange);
        }

          console.log("aattaching");
           initNoDrawerCheckoutCTA();
          }
        } catch (error) {
          
          console.error("Error loading product page:", error);
        }
      });
    });

  
}

function attachEventListenersToButtons() {
  document.querySelectorAll('.grid-product__action.wishlist').forEach(button => {
    button.addEventListener('click', handleWishListClick);
  });
  
  // document.querySelectorAll('.grid-product__action.add-to-cart').forEach(button => {
  //   button.addEventListener('click', handleAddToCartClick);
  // });

        document.querySelectorAll('.sku-item').forEach(item => {
          item.addEventListener('click', () => {
            const variantId = item.getAttribute('data-variant-id');
            const ccart = document.querySelector(".js-drawer-open-cart");
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(response => response.json())
            .then(data => {
              document.dispatchEvent(new Event('cart:build'));
              // Inject styles if not already added
  if (!document.querySelector('#cnv-cart-popup-style')) {
  const style = document.createElement('style');
  style.id = 'cnv-cart-popup-style';
  style.textContent = `
    .cnv-cart-popup {
      position: fixed;
      align-items: center;
      justify-content: center;
      flex-direction: row-reverse;
      gap: 2px;
      top: 20px;
      right: 20px;
      background: #fff;
      border: 1px solid #ddd;
      box-shadow: 0 4px 16px rgba(0,0,0,0.15);
      border-radius: 4px;
      padding: 12px;
      max-width: 300px;
      z-index: 9999;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(-10px);
      font-family: inherit;
    }
    .cnv-cart-popup.show {
      display: flex;
      opacity: 1;
      transform: translateY(0);
    }
    .cnv-cart-popup img {
      width: 60px;
      height: auto;
      float: left;
      margin-right: 10px;
      border-radius: 2px;
    }
    .cnv-cart-popup .details {
      overflow: hidden;
      font-size: 12px;
    }
    .cnv-cart-popup .title {
      font-weight: 400;
      margin-bottom: 4px;
    }
    .cnv-cart-popup .checkout-btn {
      display: block;
      text-align: center;
      margin-top: 10px;
      background: #000;
      color: #fff;
      padding: 10px;
      font-weight: 600;
      text-decoration: none;
    }
    .cnv-cart-popup .close-btn {
      position: relative;
      background: none;
      border: none;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      color: #999;
      padding: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cnv-cart-popup .close-btn:hover {
      color: #333;
    }
  `;
  document.head.appendChild(style);
}

// Create popup container
const popup = document.createElement('div');
popup.className = 'cnv-cart-popup';
document.body.appendChild(popup);

// Function to close popup
function closePopup() {
  popup.classList.remove('show');
  setTimeout(() => (popup.style.display = 'none'), 300);
}

// Function to build and show popup
fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
  .then(r => r.json())
  .then(cart => {
    if (!cart || !cart.items?.length) return;
    const item = cart.items[0]; // Most recent item (Shopify adds newest first)

    popup.innerHTML = `
      <button class="close-btn" aria-label="Close">×</button>
      <div class="details">
        <div class="title">${item.product_title} added to cart.</div>
      </div>
    `;

    // Add click handler to close button
    popup.querySelector('.close-btn').addEventListener('click', closePopup);

    popup.style.display = 'block';
    requestAnimationFrame(() => popup.classList.add('show'));

    // Auto-hide after 5s
    setTimeout(closePopup, 5000);
  })
  .catch(console.error);
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
            });
          });
        });




       // const nostoLoadedProducts = document.querySelectorAll('.product');
       //  nostoLoadedProducts.forEach(product => {
       //    const mobileAtcSizeDrawer = product.querySelector('.mobile-atc-size-drawer');
       //    const ccart = document.querySelector(".js-drawer-open-cart");
       //    if (!mobileAtcSizeDrawer) return;
       //    mobileAtcSizeDrawer.addEventListener('click', function(evt) {
       //      if (mobileAtcSizeDrawer.classList.contains('already-in-cart')) {
       //        ccart.click();
       //      }
       //      evt.stopPropagation();
       //      evt.preventDefault();
       //      // theme.SizeDrawer.open(evt, mobileAtcSizeDrawer.getAttribute('data-product-handle'));
       //    });
       //  });

  const tooltipbtns = document.querySelectorAll('.tooltip-btn');
  tooltipbtns.forEach(tooltip => {
        tooltip.addEventListener('click', function() {
            // Find the previous sibling with the class 'tooltip-content'
            let tooltipContent = this.previousElementSibling;

            tooltipContent.addEventListener('click', function() {
              tooltipContent.classList.remove('show');
              setTimeout(() => tooltipContent.style.display = 'none', 500);
            });
          
            if (tooltipContent.classList.contains('show')) {
                tooltipContent.classList.remove('show');
                setTimeout(() => {
                    tooltipContent.style.display = 'none';
                    tooltipContent.style.zIndex = '-1';
                }, 500); // Ensures fade effect completes
            } else {
                tooltipContent.style.display = 'flex';
                setTimeout(() => {
                    tooltipContent.classList.add('show');
                    tooltipContent.style.zIndex = '1';
                }, 10); // Timeout ensures smooth transition
            }

      });
  });
   // setTimeout(() => {
   //    // Select all elements with the class .nosto-product-images
   //    const nostoProductImages = document.querySelectorAll('.nosto-product-images');
      
   //    // Loop through each selected element and initialize Flickity
   //    nostoProductImages.forEach((element) => {
   //        new Flickity(element, {
   //            cellAlign: 'center',
   //            contain: true,
   //            draggable: true,
   //            wrapAround: true,
   //            pageDots: true,
   //            prevNextButtons: true,
   //            groupCells: 1
   //        });
   //    });
   //  }, 500);
}
  
function handleWishListClick(evt) {
  evt.stopPropagation();
  evt.preventDefault();
  const wishList = evt.target;
  const product = wishList.closest('.nosto-product-info');
  const wishlistbtn = wishList.closest('.wishlist');
  
  const wishListObject = {
    "epi": product.getAttribute('data-variant-id'),
    "du": product.getAttribute('data-product-url'),
    "empi": product.getAttribute('data-product-id'),
    "iu": product.getAttribute('data-product-image-url')
  };
  
  const isSaved = wishList.classList.toggle('is-saved');
  wishlistbtn.classList.toggle('is-saved');
  const action = isSaved ? 'addToWishList' : 'removeFromWishList';
  
  window._swat[action](wishListObject, function(r) {
    console.log('wishlist', isSaved ? 'added' : 'removed', r);
    // theme.updateWishList();
  });
}
  
// function handleAddToCartClick(evt) {
//   const addToCart = evt.currentTarget;
//   const product = addToCart.closest('.nosto-product-info');
//   const ccart = document.querySelector(".js-drawer-open-cart");
//   if (!addToCart) return;
    
//   evt.stopPropagation();
//   evt.preventDefault();
  
//   if (addToCart.classList.contains('already-in-cart')) {
//     ccart.click();
//   }
//   theme.SizeDrawer.open(evt, product.getAttribute('data-product-handle'));
  
// }
  
function collectSelectedFacets() {
  const selectedFacets = [];
  const facetContainers = document.querySelectorAll('.facet');
  facetContainers.forEach(container => {
    const facetName = container.querySelector('.facet-name').textContent.trim();
    const facetValues = container.querySelectorAll('.facet-value.selected, .facet-value-color.selected');
    if (facetValues.length > 0) {
      const field = container.querySelector('[id]').id;
      const values = Array.from(facetValues).map(valueElement =>
        valueElement.querySelector('a') ? valueElement.querySelector('a').title : valueElement.textContent.trim()
      );
      selectedFacets.push({ field, value: values });
    }
  });
  return selectedFacets;
}
  
function customStringify(obj) {
  if (Array.isArray(obj)) {
    return `[${obj.map(customStringify).join(',')}]`;
  } else if (typeof obj === 'object' && obj !== null) {
    const entries = Object.entries(obj).map(([key, value]) => `${key}:${customStringify(value)}`);
    return `{${entries.join(',')}}`;
  } else if (typeof obj === 'string') {
    return `"${obj}"`;
  } else {
    return String(obj);
  }
}

function customSortStringify(sortArray) {
  return '[' + sortArray.map(sortObj => `{field: "${sortObj.field}", order: ${sortObj.order}}`).join(', ') + ']';
}
  
function renderProducts(products) {
  const productGridContainer = document.getElementById('ProductGridContainer');
  productGridContainer.innerHTML = ''; 
  products.forEach(product => {
      const productElement = createProductElement(product);
      productGridContainer.appendChild(productElement);
  });
}
  
function createProductElement(product) {
  const productElement = document.createElement('div');
  productElement.classList.add('product');
  const productTitleCustom = product.url.split('/products/')[1];
  productElement.dataset.productHandle = productTitleCustom;
  const formattedPrice = product.price.toFixed(2);
  const formattedListPrice = product.listPrice.toFixed(2);

  const customBadgeField = product.customFields.find(field => field.key === 'custom-badges');
  let customBadges = customBadgeField ? customBadgeField.value : '';

         let lowest30dPriceAmount = null;
          
          if (product.skus && product.skus.length > 0) {
            const lowest30dPriceField = product.skus[0].customFields?.find(
              field => field.key === 'app--35013787649--priorprice-price'
            );
          
            if (lowest30dPriceField) {
              const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
              lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(2);
            }
          }

  if (product.listPrice > product.price) {
    // 1 - SALE AUTO %
    // 2 - OUTLET
    const newValues = [
        'gid://shopify/Metaobject/92104360026',
        'gid://shopify/Metaobject/92104687706',
    ];
    customBadges = customBadges ? JSON.parse(customBadges) : [];
    customBadges = customBadges.concat(newValues);
  }

  if (Array.isArray(customBadges)) {
    customBadges = JSON.stringify(customBadges);
  }
  
  const excludeTags = Array.isArray(product.tags1)
  ? product.tags1.filter(tag => tag.startsWith('exclude_')).map(tag => tag.replace('exclude_', ''))
  : [];

  const hasBundleTag = Array.isArray(product.tags1) && product.tags1.includes('bundle');
  
  const wcategories = product?.categoryIds || [];
  const discountBoxes = document.querySelector('.logged-in-discounts-box-collection-page');
  
  let bestDiscount = null;
  
  if (Array.isArray(wcategories) && discountBoxes) {
    let i = 1;
  
    while (true) {
      const idsSpan = discountBoxes.querySelector(`.discount-ids-${i}`);
      const percentageSpan = discountBoxes.querySelector(`.discount-percentage-${i}`);
      const titleSpan = discountBoxes.querySelector(`.discount-title-${i}`);
  
      if (!idsSpan || !percentageSpan || !titleSpan) break; // no more groups
  
      const discountIds = idsSpan.innerText.split(',').map(id => id.trim());
      const matchFound = wcategories.some(catId => discountIds.includes(String(catId)));
  
      if (matchFound) {
        const percentage = parseFloat(percentageSpan.innerText.trim());
        if (!bestDiscount || percentage > bestDiscount.percentage) {
          bestDiscount = {
            discountIdGroup: i,
            percentage,
            title: titleSpan.innerText.trim(),
            ids: discountIds
          };
        }
      }
  
      i++;
    }
  }
  
  if (bestDiscount) {
    console.log("Best Discount Found:", bestDiscount);
    // Use: bestDiscount.percentage, bestDiscount.title, etc.
  }
  
    const discountHTML = bestDiscount
    ? `<div class="nosto-discount-banner"> ${bestDiscount.title} </div>`
    : '';
  
  const discountPercentage = bestDiscount?.percentage ?? 0;
  const discountedPriceLoggedIn = (product.price * discountPercentage) / 100;
  const newPriceLoggedInF = product.price - discountedPriceLoggedIn; 
  const newPriceLoggedIn = newPriceLoggedInF.toFixed(2);
  
  const reviewsRatingField = product.customFields.find(field => field.key === 'reviews-rating');
  const reviewsRating = reviewsRatingField ? JSON.parse(reviewsRatingField.value).value : null;
  
  
  const reviewsRatingCountField = product.customFields.find(field => field.key === 'reviews-rating_count');
  const reviewsRatingCount = reviewsRatingCountField ? reviewsRatingCountField.value : 0;
  
  const productColorVariantsField = product.customFields.find(field => field.key === 'product-color_variants');
  const productColorVariants = productColorVariantsField ? productColorVariantsField.value : '';
  const productColorVariantsCount = productColorVariants ? productColorVariants.split('|').length - 1 : 0;

  const alternateImageUrls = product.alternateImageUrls ? product.alternateImageUrls.slice(0, 1) : [];
  const hiddenAlternateImages = product.alternateImageUrls ? product.alternateImageUrls.slice(1, 3) : [];  
  productElement.innerHTML = `
    <div class="search-result nosto-product-info product-bundle-${hasBundleTag}" data-product-handle="${productTitleCustom}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ''}" data-product-url="${product.url}" data-product-id="${product.productId}" data-product-image-url="${product.imageUrl}">
      <div class="top-container">
        
        <a class="nosto-product-images" href="${product.url}">
          
           <img src="${product.imageUrl}" alt="${product.name}" class="nosto-product-image">
          ${alternateImageUrls.map(url => `
            <img src="${url}" alt="${product.name}" class="nosto-product-image-secondary">
          `).join('')}

          ${hiddenAlternateImages.map(url => `
            <img src="${url}" alt="${product.name}" class="nosto-product-image-secondary" style="display: none;">
          `).join('')}
        </a>
         
        
        


          <div class="badges"></div>
          <p class="hide replace-badges">${customBadges}</p>
      
        <div class="wishlist-new-pdp">
          <button class="grid-product__action wishlist flip-animation" type="button" data-button-action="wishlist" data-empi="${product.productId}" data-with-epi="true" data-product-id="${product.productId}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ''}" data-product-url="${product.url}">
            <div class="front-side">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>
                     <span class="icon__fallback-text">Add To Wishlist</span>
           
            </div>
            <div class="back-side" aria-hidden="true">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>
                   
              <span class="icon__fallback-text">Remove From Wishlist</span>
            </div>
          </button>
        </div>
           <div class="custom-discount-badge"> </div>
      </div>
      <div class="bottom-container">
        <a class="pdp-name-bottom-container" href="${product.url}">
          <span class="search-result__name">${product.name}</span>
        </a>
        <div class="nosto-bottom-bar">
            <div class="price-container-nosto-api ${ product.price >= product.listPrice && discountHTML ? ' price-container-nosto-api-logged-in-discounts ' : ''}">
            <span ${ product.price >= product.listPrice && discountHTML ? ' class="search-result__price money grid-product__price price" ' : ''}  style="${ product.price >= product.listPrice && discountHTML ? 'color: #c1132c ;font-weight: 500;line-height: 14.4px; padding-right:1px;' : 'display:none;'}"> ${storeCurrencyGlobalSetting} ${newPriceLoggedIn}</span>
            
            <span class="search-result__price money grid-product__price price" style="${product.listPrice > product.price ? 'color: #c1132c ;font-weight: 500;' : ''} ${ product.price >= product.listPrice && discountHTML ? 'text-decoration: line-through;color: black;padding-left:4px;' : ''}">${storeCurrencyGlobalSetting} ${formattedPrice}</span>
            <span style="${ product.price >= product.listPrice && discountHTML ? 'font-weight: 500;font-size:12px;line-height: 14.4px;' : 'display:none;'}">${discountHTML} </span>  
            
           <span class="search-result__price money grid-product__price price-compare-nosto" style="${product.listPrice > product.price ? 'color: black;text-decoration: line-through;display:block;' : ''}">${storeCurrencyGlobalSetting} ${formattedListPrice}</span>
          <span class="sale-perc"></span>
   
          </div>

         
          <div data-product-handle="${productTitleCustom}" class="mobile-atc-size-drawer" aria-label="Add to cart">
          <span>+</span>
          </div>
         
          

        </div>
        <div class="product-extra-data"> 
          <a href="${product.url}" style="${productColorVariantsCount > 0 ? '' : 'display:none;'} ">
            <span> Colors +${productColorVariantsCount}  
            </span>
          </a>
          <a href="${product.url}">
            <span style=" ${reviewsRating == null ? 'display:none;' : ''}"> ★ ${reviewsRating}   </span>
          </a>
        </div>
        
        <div class="sku-container-new">
          <span class="sku-new-add-to-cart-sign">Add to cart </span>
          <div class="sku-list-new">
            ${product.skus && product.skus.length > 0 
                ? product.skus
                    .filter(sku => sku.price > 0) // Only include SKUs with price > 0
                    .map(sku => `
                      <div data-variant-id="${sku.id}" class="sku-item ${sku.availability === 'OutOfStock' ? 'unavailable' : ''}">
                        <span class="sku-name">${sku.name}</span>
                      </div>
                    `).join('') || '<div class="no-skus">No variants available</div>'
                : '<div class="no-skus">No variants available</div>'
            }
          </div>
        </div>
        
      </div>
    </div>
  `;

  
  renderBadges(productElement, product, excludeTags);

if (window._swat && typeof window._swat.fetch === 'function') {
  window._swat.fetch(function (r) {
    window.myWishList = r;

    if (window.myWishList.length > 0) {
      document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
    } else {
      document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
    }

    const wishlistButtons = document.querySelectorAll('.wishlist');
    if (wishlistButtons.length === 0) return;

    wishlistButtons.forEach(function (button) {
      const empi = button.getAttribute('data-empi');
      const epi = button.getAttribute('data-epi');
      if (empi || epi) {
        const matching_arr = window.myWishList.filter(i => i.empi === empi || i.epi === epi);
        if (matching_arr.length === 0) return;

        button.classList.add('is-saved');
      }
    });
  });
} else {
  console.warn("window._swat or its fetch method is not available. Skipping wishlist processing.");
}



  
  return productElement;
}

function renderFacets(facets) {
    const facetsContainer = document.getElementById('FacetsContainer');
    facetsContainer.innerHTML = ''; // Clear existing facets
    const filtersElement = document.createElement('div');
    const closeBtn = document.createElement('div');
    closeBtn.classList.add('close-button-facets');
    closeBtn.addEventListener('click', function () {
      facetsContainer.classList.remove('active');
    });
    filtersElement.classList.add('filters');
    filtersElement.innerHTML = 'Filters';
    facetsContainer.appendChild(filtersElement);
    facetsContainer.appendChild(closeBtn);
  
    facets.forEach(facet => {
      if (facet && Array.isArray(facet.data)) {
        const facetElement = createFacetElement(facet);
        facetsContainer.appendChild(facetElement);
      }
    });
  
    attachEventListenersToFacets();
    showFacets();
  }
  
function createFacetElement(facet) {
    const facetElement = document.createElement('div');
    facetElement.classList.add('facet');
    
    if (facet.name === "Color") {
      facetElement.innerHTML = `                  
      <div class="${facet.name} Color" id="${facet.field}">
          <div class="facet-name">${facet.name}</div>
           
             <div class="facet-values" aria-label="${facet.name}">
              ${facet.data.map(value => `
                <div class="facet-color-container">
                  <div class="facet-value-color ${value.selected ? 'selected' : ''}">
                    <button class="${value.value}" title="${value.value}"></button>
                    <svg width="12" height="12" class="selected-color" xmlns="http://www.w3.org/2000/svg"><path d="M4.248 8.188L10.422 2l.826.826-7 7L1 6.578l.812-.826z" fill="currentColor" fill-rule="evenodd"></path></svg>
                    <span class="facet-color-name" aria-label="${value.value}">${value.value}</span>
                  </div>
                </div>
              `).join('')}
            
          </div>
        </div> 
      `;
    } else if (facet.name === "Size") {
      const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 34, 36, '36-38', 37, 38, 39, '39-41', 40, 41, 42, 44, '86/92', '98/104', '110/116', '122/128', '134/140', '146/152', 'XS/S', 'M/L', 'XL/XXL', 'M', 'M/L', 'L', 'XL', 'XXL', 'XXXL', 'One Size', 'Onesize', 'XL/XXL'];
      facet.data.sort((a, b) => {
        const indexA = sizeOrder.indexOf(a.value);
        const indexB = sizeOrder.indexOf(b.value);
      
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
    
        return indexA - indexB;
      });
      
      facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data.map(value => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? 'selected' : ''}">
              ${value.value}
            </div>
          `).join('')}
        </div>
      </div>
    `;
    
    } else {
      facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data.map(value => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? 'selected' : ''}">
              ${value.value}
            </div>
          `).join('')}
        </div>
      </div>
      `;
    }
    
    return facetElement;
  }
function renderBadges(productElement, product, excludeTags) {
  const badgesContainer = productElement.querySelector('.replace-badges');
  if (badgesContainer && badgesContainer.innerHTML.trim() !== "") {
    const badgesDiv = badgesContainer.previousElementSibling;
    if (badgesDiv) {
      const content = badgesContainer.textContent.trim();
      try {
        const parsedContent = JSON.parse(content);
        const storeBadges = document.querySelectorAll('.store-badges .badge');
        const badgeMap = {};
        
        // Create a map of store badges by their IDs
        storeBadges.forEach(badge => {
          const badgeId = badge.getAttribute('data-badge-id');
          badgeMap[badgeId] = badge.outerHTML;
        });

        // Render each badge based on parsed content
        parsedContent.forEach(id => {
          let newContent = badgeMap[id] || id;
          const newElement = document.createElement('div');
          const productContainer = badgesDiv.closest('.product');
          const percDiv = productContainer ? productContainer.querySelector('.bottom-container .sale-perc') : null;

         let lowest30dPriceAmount = null;
          
          if (product.skus && product.skus.length > 0) {
            const lowest30dPriceField = product.skus[0].customFields?.find(
              field => field.key === 'app--35013787649--priorprice-price'
            );
          
            if (lowest30dPriceField) {
              const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
              lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(2);
            }
          }


          if (lowest30dPriceAmount != 0 && newContent.includes("% Sale auto")) {
            if (lowest30dPriceAmount > product.price) {
          
              const perc = ((lowest30dPriceAmount - product.price) / lowest30dPriceAmount) * 100;
              if (perc === 0) {
                newElement.style.display = 'none';
              } else {
                newContent = newContent.replace("% Sale auto", `-${perc.toFixed()}%`);
                percDiv.innerHTML = newContent;
                newElement.classList.add("hide");
              }
          
            } else if (lowest30dPriceAmount == null && product.listPrice > product.price) {
          
              const perc = ((product.listPrice - product.price) / product.listPrice) * 100;
          
              if (perc === 0) {
                newElement.style.display = 'none';
              } else {
                newContent = newContent.replace("% Sale auto", `-${perc.toFixed()}%`);
                percDiv.innerHTML = newContent;
                newElement.classList.add("hide");
              }
            } else {
          
              newElement.style.display = 'none';
            }
          }

          newElement.innerHTML = newContent;

          const badgeIdNumericPart = id.split('/').pop();
          if (excludeTags.includes(badgeIdNumericPart)) {
            newElement.style.display = 'none';
          }

badgesDiv.appendChild(newElement);

// Apply the z-index logic for each group of badges separately
const badges = badgesDiv.querySelectorAll('.badge');
const badgeGroups = {};

// Group badges by their class (e.g., q-1-p-1, q-1-p-2, etc.)
badges.forEach(badge => {
  // Extract the badge's specific group class
  const groupClass = Array.from(badge.classList).find(cls =>
    cls.match(/^q-\d+-p-\d+$/)
  );

  if (groupClass) {
    if (!badgeGroups[groupClass]) {
      badgeGroups[groupClass] = [];
    }
    badgeGroups[groupClass].push(badge);
  }
});

// Process each group separately
Object.keys(badgeGroups).forEach(groupClass => {
  const groupBadges = badgeGroups[groupClass];
  let maxZIndex = -Infinity;
  let topBadge = null;

  // Find the badge with the highest z-index in the group, excluding those in .hide divs
  groupBadges.forEach(badge => {
    if (!badge.closest('.hide')) {
      const zIndex = parseInt(badge.style.zIndex, 10) || 0;
      if (zIndex > maxZIndex) {
        maxZIndex = zIndex;
        topBadge = badge;
      }
    }
  });

  // Set opacity of all badges in the group to 0 except the top one
  groupBadges.forEach(badge => {
    if (!badge.closest('.hide') && badge !== topBadge) {
      badge.style.opacity = '0';
    } else {
      badge.style.opacity = '1'; // Ensure the top badge is visible
    }
  });
});

          
        });



      } catch (e) {
        console.error('Failed to parse content as JSON:', content);
      }
    }
  }
}


function showFacets(){
   const maxVisible = 9;
      const facetContainers = document.querySelectorAll('.facet-values');
      facetContainers.forEach(container => {
                  
        const facetValues = container.querySelectorAll('.facet-color-container, .facet-value');
        const moreLessButton = document.createElement('button');
        moreLessButton.classList.add('more-less-button');
        container.appendChild(moreLessButton);
    
        if (facetValues.length > maxVisible) {
            for (let i = maxVisible; i < facetValues.length; i++) {
                facetValues[i].classList.add('hidden');
            }
      
            moreLessButton.textContent = '+ More';
            moreLessButton.addEventListener('click', () => {
              const isHidden = facetValues[maxVisible].classList.contains('hidden');
              if (isHidden) {
                facetValues.forEach(item => item.classList.remove('hidden'));
                moreLessButton.textContent = '- Less';
              } else {
                  for (let i = maxVisible; i < facetValues.length; i++) {
                    facetValues[i].classList.add('hidden');
                  }
                  moreLessButton.textContent = '+ More';
                }
              });
              } else {
                moreLessButton.style.display = 'none';
              } 
          });
}

  const sarrowSVG = `<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M10.056 9.944L7 6.872 3.944 9.944 3 9l4-4 4 4z" fill="currentColor" fill-rule="evenodd"></path></svg>`;
  function loadElements() {
    setTimeout(() => {
      document.querySelectorAll('.facet').forEach(facet => {
        const showfacetValues = facet.querySelector('.facet-values');
        const showdivs = showfacetValues.querySelectorAll('div');
        if (showdivs.length > 9) {
          for (let i = 9; i < showdivs.length; i++) {
            showdivs[i].classList.add('hidden');
          }
  
          const button = document.createElement('button');
          button.textContent = '+ More';
          button.classList.add('toggle-button');
          facet.appendChild(button);
  
          button.addEventListener('click', function () {
            const isExpanded = button.textContent === '+ More';
            for (let i = 9; i < showdivs.length; i++) {
              showdivs[i].classList.toggle('hidden', !isExpanded);
            }
            button.textContent = isExpanded ? '- Less' : '+ More';
          });
        }
  
        const facetName = facet.querySelector('.facet-name');
        facetName.insertAdjacentHTML('beforeend', sarrowSVG);
        facetName.addEventListener('click', () => {
          const isHidden = showfacetValues.style.display === 'none' || !showfacetValues.style.display;
          showfacetValues.style.display = isHidden ? 'flex' : 'none';
          facetName.classList.toggle('toggled', !isHidden);
        });
  
        function handleWishListClick(evt) {
          evt.stopPropagation();
          evt.preventDefault();
          const wishList = evt.target;
          const product = wishList.closest('.nosto-product-info');
          const wishlistbtn = wishList.closest('.wishlist');
  
          const wishListObject = {
            "epi": product.getAttribute('data-variant-id'),
            "du": product.getAttribute('data-product-url'),
            "empi": product.getAttribute('data-product-id'),
            "iu": product.getAttribute('data-product-image-url')
          };
  
          const isSaved = wishList.classList.toggle('is-saved');
          wishlistbtn.classList.toggle('is-saved');
          const action = isSaved ? 'addToWishList' : 'removeFromWishList';
  
          window._swat[action](wishListObject, function(r) {
            console.log('wishlist', isSaved ? 'added' : 'removed', r);
            // theme.updateWishList();
          });
        }
      });

 
    }, 300);
  };
  
  loadElements();
  
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  function updateSelectedFacetsDisplay(selectedFacets) {
    const filtersDiv = document.querySelector('.filters');
    if (!filtersDiv) return; 
  
    let selectedFacetsDiv = filtersDiv.querySelector('.selected-facets');
    if (!selectedFacetsDiv) {
      selectedFacetsDiv = document.createElement('div');
      selectedFacetsDiv.classList.add('selected-facets');
      filtersDiv.appendChild(selectedFacetsDiv);
    }
    selectedFacetsDiv.innerHTML = ''; 
  
    selectedFacets.forEach(facet => {
      facet.value.forEach(value => {
        const facetValue = document.createElement('span');
        facetValue.classList.add('facet-value-item');
        facetValue.textContent = value;
        const closeSvg = '<svg width="15" class="close-facet" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M11.865 4.27l-3.48 3.48 3.48 3.48-.885.885-3.48-3.48-3.48 3.48-.885-.885 3.48-3.48-3.48-3.48.885-.885 3.48 3.48 3.48-3.48z" fill="currentColor" fill-rule="evenodd"></path></svg>';
        facetValue.insertAdjacentHTML('beforeend', closeSvg);
        selectedFacetsDiv.appendChild(facetValue);
      });
    });
  
    attachEventListenersToCloseFacets(); 
  }
  
  function attachEventListenersToCloseFacets() {
    document.querySelectorAll('.close-facet').forEach(closeIcon => {
      closeIcon.addEventListener('click', function(event) {
        const facetValueItem = event.target.closest('.facet-value-item');
        const valueToRemove = facetValueItem.textContent.trim();
  
        selectedFacets = selectedFacets.map(facetGroup => ({
          field: facetGroup.field,
          value: facetGroup.value.filter(value => value !== valueToRemove)
        })).filter(facetGroup => facetGroup.value.length > 0); 
                                 
        updateURL(currentPage, selectedFacets);
        renderProductsAndPagination(currentPage, selectedFacets);
        updateSelectedFacetsDisplay(selectedFacets); 
        facetValueItem.remove(); 
      });
    });
  }
    // Function to show the loader
  function showLoader() {
    const loader = document.querySelector('.loader-container');
    const loaderBar = document.querySelector('.loader-bar');
    loader.style.display = 'flex'; // Show the loader

    if (!loader || !loaderBar) return;

    // Gradually increase the width of the loader bar to simulate loading progress
    let progress = 0;
    const interval = setInterval(() => {
      if (progress >= 90) {
        clearInterval(interval);
      } else {
        progress += 5; // Increase by 2% every interval (this can be adjusted)
        loaderBar.style.width = progress + '%';
      }
    }, 100); // Update every 100ms
  }


  // Function to hide the loader after API response
function hideLoader() {
  const loader = document.querySelector('.loader-container');
  const loaderBar = document.querySelector('.loader-bar');

  if (!loader || !loaderBar) return; // Exit if elements don't exist

  // Hide the loader and reset the loader bar.
  loader.style.display = 'none';
  loaderBar.style.width = '0%';

  // If this is an iOS device and the page was restored from cache,
  // skip custom scroll restoration to allow native behavior.
  if (isIOS() && isBFCache) {
    return;
  }

  // Otherwise, restore the scroll position using saved value (if any)
  setTimeout(() => {
    requestAnimationFrame(() => {
      const collectionKey = window.location.pathname;
      const savedScroll = sessionStorage.getItem('collectionScrollPosition_' + collectionKey);
      if (savedScroll) {
        window.scrollTo({
          top: parseInt(savedScroll, 10),
          left: 0,
          behavior: 'smooth' // Change to 'auto' if smooth scrolling gives issues on some devices.
        });
        sessionStorage.removeItem('collectionScrollPosition_' + collectionKey);
      }
    });
  }, 50);
}

  document.addEventListener('DOMContentLoaded', function () {
    const facetsButton = document.querySelector('.facets-button');
    const facetsContainer = document.getElementById('FacetsContainer');
  
    facetsButton.addEventListener('click', function () {
      facetsContainer.classList.toggle('active');
    });
  
    document.addEventListener('click', function (event) {
      if (!facetsContainer.contains(event.target) && !facetsButton.contains(event.target)) {
        facetsContainer.classList.remove('active');
      }
    });
  });  
    
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get('page')) || 1;
    const sortOption = urlParams.get('sort') || 'popularity';
    currentPage = page;
    selectedFacets = getSelectedFacetsFromUrl();
    
   // Clear the product grid if page > 1 so that we load pages 1...currentPage
    if (page > 1) {
      document.getElementById('ProductGridContainer').innerHTML = '';
    }
    
    renderProductsAndPagination(page, selectedFacets, sortOption);
  
    document.getElementById('LoadMoreButton').addEventListener('click', function() {
       const button = this;
      
      // Disable button and show loader
      button.disabled = true;
      const originalText = button.innerHTML;
      button.innerHTML = '<span style="display: inline-block; width: 16px; height: 16px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 0.8s linear infinite;"></span>';
      
      // Add CSS animation if not already present
      if (!document.getElementById('loader-style')) {
        const style = document.createElement('style');
        style.id = 'loader-style';
        style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
        document.head.appendChild(style);
      }
      
      currentPage++;
      updateURL(currentPage, selectedFacets, sortOption);
      
      renderProductsAndPagination(currentPage, selectedFacets, sortOption);
      
      // Re-enable button after content loads (adjust timeout as needed)
      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 1500);
    });
  
    attachEventListenersToFacets();
    document.getElementById('sort-options').addEventListener('change', function() {
      const newSortOption = this.value;
      updateURL(1, selectedFacets, newSortOption);
      currentPage = 1;
      document.getElementById('ProductGridContainer').innerHTML = '';
      renderProductsAndPagination(currentPage, selectedFacets, newSortOption);
      updateSelectedFacetsDisplay(selectedFacets); 
    });   
        //   document.querySelectorAll('.sku-item').forEach(item => {
        //   item.addEventListener('click', () => {
        //     const variantId = item.getAttribute('data-variant-id');
        //     const ccart = document.querySelector(".js-drawer-open-cart");
            
        //     fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json'
        //       },
        //       body: JSON.stringify({ id: variantId, quantity: 1 })
        //     })
        //     .then(response => response.json())
        //     .then(data => {
        //       document.dispatchEvent(new Event('cart:build'));
        //       ccart.click();
        //     })
        //     .catch(error => {
        //       console.error('Error adding to cart:', error);
        //     });
        //   });
        // });
showLoader();
  });
  
  (function() {
 
  const style = document.createElement('style');
  style.innerHTML = `
    a.nosto-product-images[data-plp-lock-hover] img,
    a.nosto-product-images[data-plp-lock-hover]:hover img{
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      transition: none !important;
    }
    a.nosto-image-container[data-plp-pseudo-killed]::before,
    a.nosto-image-container[data-plp-pseudo-killed]::after{
      content: none !important;
      background: none !important;
      opacity: 0 !important;
      pointer-events: none !important;
      transition: none !important;
    }
 
    /* Slider layout */
    .plp-viewport{ position:relative; width:100%; height:100%; overflow:hidden; touch-action: pan-y; }
    .plp-track{ display:flex; width:100%; height:100%; will-change:transform; }
    .plp-slide{ flex:0 0 100%; width:100%; height:100%; position:relative; }
    .plp-slide-bg{ position:absolute; inset:0; background-size:cover; background-position:center; }
    .plp-dots{
      position:absolute; left:85%; bottom:20px; transform:translateX(-50%);
      display:flex; gap:8px; z-index:10; pointer-events:auto;
    }
    .plp-dot{ width:5px; height:5px; border-radius:50%; background:#fff; cursor:pointer; transition:background .2s ease; touch-action: manipulation; }
    .plp-dot.active{ background:#000; }
    .plp-dragging{ cursor:grabbing; }
 
    .plp-viewport .plp-slide img{
      display:block !important;
      opacity:1 !important;
      visibility:visible !important;
      pointer-events:auto !important;
      position:static !important;
      top:auto !important; left:auto !important;
      padding-top:0 !important;
      width:100% !important; height:100% !important; object-fit:cover !important;
    }
    .plp-viewport .plp-slide img.nosto-product-image-secondary{
      display:block !important;
      opacity:1 !important;
      visibility:visible !important;
      pointer-events:auto !important;
      position:static !important;
      top:auto !important; left:auto !important;
      padding-top:0 !important;
    }
 
    @media (max-width:768px){
      .nosto-list-item .top-container > .nosto-product-images[data-plp-lock-hover] {
        padding-top: 0 !important;
      }
    }
  `;
  document.head.appendChild(style);
 
  // Utils
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));
  const bgUrlFromCS = (cs) => {
    const bg = cs.backgroundImage;
    if (!bg || bg === 'none') return '';
    const m = bg.match(/url\(["']?([^"')]+)["']?\)/i);
    return m ? m[1] : '';
  };
  const pseudoBG = (el, pseudo) => bgUrlFromCS(getComputedStyle(el, pseudo));
 
  function enforceVisible(img) {
    const inline = (img.getAttribute('style') || '').toLowerCase();
    if (inline.includes('display:none')) img.style.display = 'block';
    if (img.classList.contains('nosto-product-image-secondary')) {
      img.style.paddingTop = '0';
      img.style.position = 'static';
      img.style.top = 'auto';
      img.style.left = 'auto';
      img.style.opacity = '1';
      img.style.pointerEvents = 'auto';
    }
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.visibility = 'visible';
  }
 
  function makeImg(src, cls, hidden, altText) {
    const img = document.createElement('img');
    img.className = cls;
    img.src = src;
    if (altText) img.alt = altText;
    if (hidden) img.style.display = 'none';
    return img;
  }
 
  function wrapTop(el) {
    if (el.parentElement && el.parentElement.classList.contains('top-container')) return el.parentElement;
    const w = document.createElement('div');
    w.className = 'top-container';
    el.parentElement.insertBefore(w, el);
    w.appendChild(el);
    return w;
  }
 
  // Harvest
  function harvestUrlsFromNonWorkingAnchor(anchor) {
    const urls = [];
    try {
      const u1 = pseudoBG(anchor, '::before');
      const u2 = pseudoBG(anchor, '::after');
      if (u1) urls.push(u1);
      if (u2) urls.push(u2);
    } catch (_) {}
    if (urls.length < 2) {
      Array.from(anchor.children).forEach(div => {
        if (div.tagName !== 'DIV') return;
        const cs = getComputedStyle(div);
        if (cs.position === 'absolute') {
          const bg = bgUrlFromCS(cs);
          if (bg) urls.push(bg);
        }
      });
    }
    if (urls.length < 1) {
      const cont = anchor.closest('.nosto-list-item, .grid-item, .grid-product');
      const dataImg = cont && cont.getAttribute('data-product-image-url');
      if (dataImg) urls.push(dataImg);
      if (urls.length < 1) {
        anchor.querySelectorAll('img[src]').forEach(img => urls.push(img.src));
      }
    }
    return uniq(urls);
  }
 
  function harvestWithRetry(anchor, tries, done) {
    let attempt = 0;
    const tick = () => {
      const urls = harvestUrlsFromNonWorkingAnchor(anchor);
      if (urls.length >= 2 || attempt >= tries) {
        done(urls);
      } else {
        attempt++;
        requestAnimationFrame(tick);
      }
    };
    tick();
  }
 
  // Transform
  function transformAnchor(anchor) {
    if (!anchor || anchor.classList.contains('nosto-product-images') || anchor.hasAttribute('data-plp-transformed')) return;
    const href = anchor.getAttribute('href') ||
      anchor.getAttribute('product-url') ||
      anchor.getAttribute('data-product-url') || '#';
    const alt = anchor.getAttribute('alt') ||
      (anchor.closest('.nosto-product-info')?.querySelector('.nosto-product-name')?.textContent?.trim()) || '';
    harvestWithRetry(anchor, 4, (urls) => {
      if (urls.length === 0) return;
      anchor.setAttribute('data-plp-pseudo-killed', '1');
      anchor.setAttribute('data-plp-transformed', '1');
      const newA = document.createElement('a');
      newA.className = 'nosto-product-images';
      newA.href = href;
      newA.setAttribute('data-plp-lock-hover', '1');
      newA.appendChild(makeImg(urls[0], 'nosto-product-image', false, alt));
      if (urls[1]) newA.appendChild(makeImg(urls[1], 'nosto-product-image-secondary', false, alt));
      for (let i = 2; i < urls.length; i++) newA.appendChild(makeImg(urls[i], 'nosto-product-image-secondary', true, alt));
      const utilities = [];
      Array.from(anchor.children).forEach(ch => {
        const cs = getComputedStyle(ch);
        const isLayer = (cs.position === 'absolute') && !!bgUrlFromCS(cs);
        if (!isLayer) utilities.push(ch);
      });
      anchor.parentElement.insertBefore(newA, anchor);
      const top = wrapTop(newA);
      utilities.forEach(n => {
        try {
          top.appendChild(n);
        } catch (_) {}
      });
      Array.from(anchor.children).forEach(ch => {
        const cs = getComputedStyle(ch);
        if (cs.position === 'absolute' && bgUrlFromCS(cs)) ch.remove();
      });
      anchor.remove();
    });
  }
 
  function transformAll() {
    document.querySelectorAll('a.nosto-image-container, a.img-1, a.nosto-image-container.img-1')
      .forEach(transformAnchor);
  }
 
  // Slider
  function buildCarousel(host, frames) {
    if (!frames || frames.length < 2) return;
    host.innerHTML = '';
    const viewport = document.createElement('div');
    viewport.className = 'plp-viewport';
    const track = document.createElement('div');
    track.className = 'plp-track';
    viewport.appendChild(track);
    host.appendChild(viewport);
    frames.forEach(f => {
      const slide = document.createElement('div');
      slide.className = 'plp-slide';
      const img = f.el;
      enforceVisible(img);
      slide.appendChild(img);
      track.appendChild(slide);
    });
    const dots = document.createElement('div');
    dots.className = 'plp-dots';
    frames.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.className = 'plp-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('role', 'button');
      dot.setAttribute('aria-label', `Image ${i+1}`);
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        goTo(i, true);
      }, {
        passive: false
      });
      dots.appendChild(dot);
    });
    host.appendChild(dots);
    let index = 0,
      startX = 0,
      startY = 0,
      currentX = 0,
      dragging = false,
      hLock = false,
      vCancel = false,
      moved = 0;
    const widthOf = el => Math.max(1, el.clientWidth || el.getBoundingClientRect().width || 1);
    let width = widthOf(viewport);
    const setTransition = on => track.style.transition = on ? 'transform .25s ease-out' : 'none';
    const setTranslate = px => track.style.transform = `translateX(${px}px)`;
    const updateDots = () => Array.from(dots.children).forEach((d, i) => d.classList.toggle('active', i === index));
    const goTo = (i, anim) => {
      index = clamp(i, 0, frames.length - 1);
      snap(anim);
    };
    const snap = (anim) => {
      const off = -index * width;
      setTransition(!!anim);
      setTranslate(off);
      updateDots();
      if (anim) {
        const done = () => {
          track.removeEventListener('transitionend', done);
          setTransition(false);
        };
        track.addEventListener('transitionend', done);
      }
    };
    setTransition(false);
    setTranslate(0);
    requestAnimationFrame(() => {
      width = widthOf(viewport);
      snap(false);
    });
    const H_T = 8,
      V_T = 8,
      SNAP = 0.12;
 
    function down(x, y) {
      startX = x;
      startY = y;
      width = widthOf(viewport);
      currentX = -index * width;
      dragging = true;
      hLock = false;
      vCancel = false;
      moved = 0;
      setTransition(false);
      viewport.classList.add('plp-dragging');
    }
 
    function move(x, y, e) {
      if (!dragging) return;
      const dx = x - startX,
        dy = y - startY;
      moved = Math.max(moved, Math.abs(dx));
      if (!hLock && !vCancel) {
        if (Math.abs(dy) > V_T && Math.abs(dy) > Math.abs(dx)) {
          vCancel = true;
          viewport.classList.remove('plp-dragging');
          return;
        }
        if (Math.abs(dx) > H_T && Math.abs(dx) > Math.abs(dy)) {
          hLock = true;
        }
      }
      if (hLock) {
        if (e && e.preventDefault) e.preventDefault();
        const atFirst = index === 0,
          atLast = index === frames.length - 1;
        let dragX = dx;
        if ((atFirst && dx > 0) || (atLast && dx < 0)) dragX = dx * 0.35;
        setTranslate(currentX + dragX);
      }
    }
 
    function up(x, y, e) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('plp-dragging');
      if (vCancel || !hLock) return;
      const dx = x - startX,
        adx = Math.abs(dx),
        trig = width * SNAP;
      if (adx > trig) {
        index = clamp(index + (dx < 0 ? 1 : -1), 0, frames.length - 1);
      }
      snap(true);
      if (e && moved > 5) {
        if (e.cancelable) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
      }
    }
    viewport.addEventListener('pointerdown', e => down(e.clientX, e.clientY), {
      passive: true
    });
    viewport.addEventListener('pointermove', e => move(e.clientX, e.clientY, e), {
      passive: false
    });
    viewport.addEventListener('pointerup', e => up(e.clientX, e.clientY, e), {
      passive: false
    });
    viewport.addEventListener('pointercancel', () => {
      dragging = false;
      viewport.classList.remove('plp-dragging');
    }, {
      passive: true
    });
    viewport.addEventListener('touchstart', e => {
      const t = e.changedTouches[0];
      down(t.clientX, t.clientY);
    }, {
      passive: true
    });
    viewport.addEventListener('touchmove', e => {
      const t = e.changedTouches[0];
      move(t.clientX, t.clientY, e);
    }, {
      passive: false
    });
    viewport.addEventListener('touchend', e => {
      const t = e.changedTouches[0];
      up(t.clientX, t.clientY, e);
    }, {
      passive: false
    });
    viewport.addEventListener('touchcancel', () => {
      dragging = false;
      viewport.classList.remove('plp-dragging');
    }, {
      passive: true
    });
    const anchor = host.closest('a');
    if (anchor) {
      anchor.addEventListener('click', e => {
        if (moved > 5) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, {
        capture: true
      });
    }
    const ro = new ResizeObserver(() => {
      width = widthOf(viewport);
      snap(false);
    });
    ro.observe(viewport);
    const fix = new MutationObserver((recs) => {
      for (const r of recs) {
        const t = r.target;
        if (t && t.tagName === 'IMG') enforceVisible(t);
      }
    });
    Array.from(track.querySelectorAll('img')).forEach(img => {
      enforceVisible(img);
      fix.observe(img, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    });

    
  }
 
  function buildSlider(container) {
    if (!container || container.getAttribute('data-plp-built') === '1') return;
    const imgs = Array.from(container.querySelectorAll('img'));
    if (imgs.length < 2) {
      container.setAttribute('data-plp-built', '1');
      return;
    }
    container.querySelectorAll('.plp-dots,.plp-viewport').forEach(n => n.remove());
    const host = document.createElement('div');
    host.style.position = 'relative';
    host.style.width = '100%';
    const first = imgs[0];
    if (first && first.naturalWidth && first.naturalHeight) {
      host.style.aspectRatio = `${first.naturalWidth} / ${first.naturalHeight}`;
    } else {
      host.style.aspectRatio = '1 / 1';
      if (first && !first.complete) {
        first.addEventListener('load', () => {
          if (first.naturalWidth && first.naturalHeight) {
            host.style.aspectRatio = `${first.naturalWidth} / ${first.naturalHeight}`;
          }
        }, {
          once: true
        });
      }
    }
    container.appendChild(host);
    const frames = imgs.map(el => ({
      kind: 'img',
      el
    }));
    buildCarousel(host, frames);
    container.setAttribute('data-plp-built', '1');
  }
 
  // Run
  function run() {
    document.querySelectorAll('a.nosto-image-container,a.img-1,a.nosto-image-container.img-1').forEach(transformAnchor);
    document.querySelectorAll('.nosto-product-images').forEach(a => {
      a.setAttribute('data-plp-lock-hover', '1');
      buildSlider(a);
    });
  }
 
  run();
  let scheduled = false;
  const mo = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  });
  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
  function initNoDrawerCheckoutCTA() {
  (function() {
  const VER = 'CNV-PDP NoDrawer Checkout CTA v1.6 (Nosto moves after ATC under .under-atc-text)';
  if (window.__cnvNoDrawerCheckoutCTA_v16) {
    console.warn(`[${VER}] already applied`);
    return;
  }
  window.__cnvNoDrawerCheckoutCTA_v16 = true;
  // Utils
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.prototype.slice.call(r.querySelectorAll(s));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts || false);
  const FORM_SEL = '.product-form, .product-single__form, form[action="/cart/add"]';
  // Styles
  (function injectStyle() {
    if (q('#cnv-nodrawer-style')) return;
    const css = `
      #cnv-checkout-cta { display:none; width:100%; clear:both; margin-top:10px; overflow:hidden; transition:max-height .25s ease; }
      #cnv-checkout-cta.cnv-open { display:block; max-height:160px; }
      #cnv-checkout-cta:not(.cnv-open) { max-height:0; }
      #cnv-checkout-cta .cnv-checkout-btn {
        display:block; width:100%; text-align:center;
        background:#000; color:#fff; border:0; border-radius:0px;
        padding:14px 16px; font-weight:600; cursor:pointer; text-decoration:none;
      }
      #cnv-checkout-cta .cnv-checkout-btn:focus { outline:2px solid #111; outline-offset:2px; }
      .cnv-nosto-below-cta { width:100% !important; display:block !important; clear:both !important; }
    `;
    const s = document.createElement('style');
    s.id = 'cnv-nodrawer-style';
    s.textContent = css;
    document.head.appendChild(s);
  })();
  // Checkout CTA
  function getCheckoutHref() {
    const candidates = [
      '#CartDrawer a[href*="/check"]',
      '.ajaxcart__checkout[href*="/check"]',
      '.mini-cart a[href*="/check"]',
      '.cart__checkout[href*="/check"]',
      'a.btn--checkout[href*="/check"]',
      'a[href^="/checkout"]'
    ];
    for (const sel of candidates) {
      const a = q(sel);
      if (a && a.getAttribute('href')) return a.getAttribute('href');
    }
    return '/cart';
  }
  function ensureCheckoutCTA() {
    const btnWrap = q('.pdp-button-container') || q(FORM_SEL);
    if (!btnWrap) return null;
    let cta = q('#cnv-checkout-cta', btnWrap) || q('#cnv-checkout-cta');
    if (!cta || (cta && cta.parentElement !== btnWrap)) {
      if (cta && cta.parentElement !== btnWrap) {
        btnWrap.appendChild(cta);
      } else if (!cta) {
        cta = document.createElement('div');
        cta.id = 'cnv-checkout-cta';
        const a = document.createElement('a');
        a.className = 'cnv-checkout-btn';
        a.textContent = 'Checkout';
        a.href = getCheckoutHref();
        a.rel = 'nofollow';
        cta.appendChild(a);
        btnWrap.appendChild(cta);
      }
    } else {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
    }
    return cta;
  }
  function revealCheckoutCTA() {
    const cta = ensureCheckoutCTA();
    if (cta) {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
      cta.classList.add('cnv-open');
    }
  }

  // Nosto
  function getCandidateNostoEls() {
    const ids = [
      '#productpage_nosto_8', '#productpage-nosto-8', '#productpage-nosto_2',
      '.nosto_element#productpage_nosto_8', '.nosto_element#productpage-nosto-2'
    ];
    const found = ids.map(sel => q(sel)).filter(Boolean);
    qa('.product-single__meta .nosto_element').forEach(el => {
      if (!found.includes(el)) found.push(el);
    });
    return found;
  }
  function nostoHasContent(root) {
    if (!root) return false;
    const sel = [
      '.nosto-list-item',
      '.nosto-product',
      '.product, .grid-product, .product-card',
      'img[src], img[data-src], img[data-srcset]',
      'a[href*="/products/"]'
    ].join(',');
    if (root.querySelector(sel)) return true;
    const text = (root.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 80;
  }
  function moveNostoUnderATCTextWhenReady(timeoutMs = 15000) {
    const underAtc = q('.under-atc-text');
    if (!underAtc) return;
    const nostos = getCandidateNostoEls();
    if (!nostos.length) return;
    const doMove = (el) => {
      if (!el) return;
      el.classList.add('cnv-nosto-below-cta');
      underAtc.insertAdjacentElement('afterend', el);
    };
    const ready = nostos.find(n => nostoHasContent(n));
    if (ready) {
      doMove(ready);
      return;
    }
    const observers = [];
    const stopAll = () => observers.forEach(o => o.disconnect());
    nostos.forEach(nosto => {
      const obs = new MutationObserver(() => {
        if (nostoHasContent(nosto)) {
          stopAll();
          doMove(nosto);
        }
      });
      obs.observe(nosto, {
        childList: true,
        subtree: true
      });
      observers.push(obs);
    });
    setTimeout(stopAll, timeoutMs);
  }
  // Variant handling
  function getCurrentVariantId(scope = document) {
    let cand = scope.querySelector('input[type="radio"][data-variant-id].selected') ||
      scope.querySelector('input[type="radio"][data-variant-id]:checked');
    if (cand && cand.getAttribute('data-variant-id')) return cand.getAttribute('data-variant-id');
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (checked) {
      const wrapper = checked.closest('.variant-input');
      if (wrapper && wrapper.getAttribute('data-variant-id')) {
        return wrapper.getAttribute('data-variant-id');
      }
    }
    const selWrap = scope.querySelector('.variant-input.selected');
    if (selWrap && selWrap.getAttribute('data-variant-id')) {
      return selWrap.getAttribute('data-variant-id');
    }
    const sel = scope.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    const hidden = scope.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }
  function syncVariantIdIntoForm(form) {
    if (!form) return null;
    const current = getCurrentVariantId(form) || getCurrentVariantId(document);
    if (!current) return null;
    const hidden = form.querySelector('input[name="id"]');
    const select = form.querySelector('select[name="id"]');
    if (hidden && hidden.value !== String(current)) hidden.value = String(current);
    if (select && select.value !== String(current)) select.value = String(current);
    return String(current);
  }
  // ATC UI states
  function setATCStateSuccess(form) {
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (!atcBtn) return;
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    atcBtn.classList.add('cnv-atc-success');
    const original = txt.getAttribute('data-default-text') || 'Add To Cart';
    txt.setAttribute('data-original-text', original);
    txt.textContent = 'Added To Cart';
  }
  function resetATCState(form) {
    const atcBtn = form && (form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]'));
    if (!atcBtn) return;
    atcBtn.classList.remove('cnv-atc-success');
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    const def = (txt.getAttribute('data-default-text') || txt.getAttribute('data-original-text') || 'Add To Cart').trim();
    txt.textContent = def;
    const cta = ensureCheckoutCTA();
    if (cta) cta.classList.remove('cnv-open');
  }
  function refreshCartQuietly() {
    try {
      fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(r => r.ok ? r.json() : null)
        .then(cart => {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: {
              cart
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:build', {
            detail: {
              cart
            }
          }));
        })
        .catch(() => {});
    } catch (e) {}
  }
  // Drawer guard
  let guardUntil = 0;
  function armDrawerGuard(ms = 5000) {
    guardUntil = Date.now() + ms;
  }
  const CART_OPEN_SEL = [
    '.js-drawer-open-cart', '[data-action="open-drawer"]', '[data-drawer="cart"]',
    '[data-drawer-trigger="cart"]', '.cart-toggle', '.header-cart', '.site-header__cart-toggle'
  ].join(',');
  on(document, 'click', function(e) {
    const tgt = e.target && e.target.closest && e.target.closest(CART_OPEN_SEL);
    if (!tgt) return;
    if (Date.now() < guardUntil) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }, true);
  // Submit interception
  on(document, 'submit', function(e) {
    const form = e.target;
    if (!form || !form.matches(FORM_SEL)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    const currentVariantId = syncVariantIdIntoForm(form);
    if (!currentVariantId) return;
    armDrawerGuard(5000);
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
    }
    const fd = new FormData(form);
    fd.set('id', String(currentVariantId));
    fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        setATCStateSuccess(form);
        revealCheckoutCTA();
        moveNostoUnderATCTextWhenReady(); // move after ATC only after add
        refreshCartQuietly();
        
      })
      .catch(err => {
        console.error('[NoDrawer] ATC error', err);
      })
      .finally(() => {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-busy');
        }
      });
  }, true);
  // Observe DOM (variant swaps, PJAX, async Nosto)
  (function observeProductArea() {
    const root = q('#productSection') || q('.combined-product') || q('.product-single__meta') || document.documentElement;
    const mo = new MutationObserver(() => {
      const form = q(FORM_SEL);
      if (form) syncVariantIdIntoForm(form);
      ensureCheckoutCTA();
    });
    mo.observe(root, {
      childList: true,
      subtree: true
    });
  })();
  // Variant change resets
  (function bindVariantReset() {
    const container = q('#productSection') || q('.product-single__meta') || document;
    on(container, 'change', function(e) {
      if (!e.target) return;
      if (e.target.matches('input[type="radio"], select')) {
        const form = q(FORM_SEL);
        syncVariantIdIntoForm(form);
        resetATCState(form);
        ensureCheckoutCTA();
      }
    }, true);
    on(document, 'variant:change', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
    on(document, 'variantSwitched', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
  })();
  // Boot
  (function boot() {
    const form = q(FORM_SEL);
    if (form) syncVariantIdIntoForm(form);
    ensureCheckoutCTA();
  })();


})();
}

const style = document.createElement('style');
style.textContent = `
  .custom-discount-badge {
    position: absolute;
    top: 50px; /* adjust this to set the height we want this visible at */
    z-index: 1; /* adjust if you want to display on top of something else */
    left: 0;
    width: 30px !important;
    background:  #264A59 !important;
    color: white !important;
  }
  /* Inner badge element coming from third party */
  .custom-discount-badge .badge {
    width: 30px !important;
    background:  #264A59 !important;
    color: white !important;
  }
  .custom-discount-badge .q-2-p-2{
    top: unset !Important;
    left: unset !Important;
    position: relative !Important;
    margin: 0 !Important;
    padding: 0 18px;
  }

  @media screen and (max-width: 768px) {
    .custom-discount-badge {
      top: 50px; /* adjust this to set the height we want this visible at - mobile */
      z-index: 1; /* adjust if you want to display on top of something else */
      width: 30px !important;
      background:  #264A59 !important;
      color: white !important;
    }
    .custom-discount-badge .badge {
      width: 30px !important;
    }

  }
`;
document.head.appendChild(style);
// Badge functionality with retry for late loaded elements
function applyBadgesV1() {
  const saleParcElements = document.querySelectorAll('.sale-perc');
  let updated = false;
  saleParcElements.forEach(salePerc => {
    const parent = salePerc.closest('.search-result');
    if (parent) {
      const badgeContainer = parent.querySelector('.custom-discount-badge');
      if (badgeContainer) {
        badgeContainer.innerHTML = salePerc.innerHTML;
        updated = true;
      }
    }
  });
  return updated;
}
// Run once immediately
let v1Applied = applyBadgesV1();
// Retry if elements load late
if (!v1Applied) {
  const retryInterval = setInterval(() => {
    v1Applied = applyBadgesV1();
    if (v1Applied) {
      clearInterval(retryInterval);
    }
  }, 500);
}